export default __webpack_public_path__ + "static/media/t14.min.bdfdfdf6.png";